module.exports = __webpack_public_path__ + "static/img/pillar-top_256.1b2bf3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pillar-top_256.png
// module id = zEcj
// module chunks = 0